/**
 * @generated SignedSource<<a7b6e099b37b9e53e28569e4c0f9daf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type BountyStatus = "ACTIVE" | "ACTIVE_BUT_BONUS_EXISTS" | "CLAIMED" | "FINISHED" | "PAUSED" | "RE_CLAIMABLE" | "%future added value";
export type BountiesContextBountyUpdatedSubscription$variables = {
  code?: string | null;
};
export type BountiesContextBountyUpdatedSubscription$data = {
  readonly bountyUpdated: {
    readonly bountyId: number;
    readonly amount: number;
    readonly currency: string;
    readonly title: string;
    readonly subtitle: string;
    readonly extendedInfo: string;
    readonly bgImageUrl: string | null;
    readonly rating: number;
    readonly status: BountyStatus;
    readonly expires: string | null;
    readonly claimCount: number;
    readonly claimLimit: number;
  } | null;
};
export type BountiesContextBountyUpdatedSubscription = {
  variables: BountiesContextBountyUpdatedSubscription$variables;
  response: BountiesContextBountyUpdatedSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "Bounty",
    "kind": "LinkedField",
    "name": "bountyUpdated",
    "plural": false,
    "selections": [
      {
        "alias": "bountyId",
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "extendedInfo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bgImageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expires",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimLimit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BountiesContextBountyUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BountiesContextBountyUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8ccfb94b1cfbf4e8550dedd3a6bebc67",
    "id": null,
    "metadata": {},
    "name": "BountiesContextBountyUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription BountiesContextBountyUpdatedSubscription(\n  $code: String\n) {\n  bountyUpdated(code: $code) {\n    bountyId: id\n    amount\n    currency\n    title\n    subtitle\n    extendedInfo\n    bgImageUrl\n    rating\n    status\n    expires\n    claimCount\n    claimLimit\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8d300d5b087c49ecac414f5a4bc19d3";

export default node;
